import React from "react";
import { NavLink } from "react-router-dom";
import { Home as HomeIcon, Compass, Users, User, ShoppingBag } from "lucide-react";
import { useT } from "../context/LanguageContext";

export default function BottomNav() {
  const { t } = useT();
  const tabs = [
    { to: "/v2",         label: t("v2.nav.myleague"), icon: HomeIcon,    end: true,  testId: "v2-tab-home" },
    { to: "/v2/explore", label: t("v2.nav.explore"),  icon: Compass,     end: false, testId: "v2-tab-explore" },
    { to: "/v2/social",  label: t("v2.nav.social"),   icon: Users,       end: false, testId: "v2-tab-social" },
    { to: "/v2/store",   label: t("v2.nav.store"),    icon: ShoppingBag, end: false, testId: "v2-tab-store" },
    { to: "/v2/profile", label: t("v2.nav.profile"),  icon: User,        end: false, testId: "v2-tab-profile" },
  ];
  return (
    <nav className="absolute bottom-0 left-0 right-0 h-20 bg-[#0A0A14]/95 backdrop-blur-md border-t border-[#1F1F2A] flex items-stretch justify-around px-1 pb-safe" data-testid="v2-bottom-nav">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          data-testid={tab.testId}
          className={({ isActive }) =>
            `relative flex flex-col items-center justify-center gap-1 flex-1 transition-colors ${
              isActive ? "text-white" : "text-[#52525B] hover:text-[#A1A1AA]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-gradient-to-r from-[#7C3AED] to-[#3B82F6] rounded-full" />
              )}
              <tab.icon className={`w-5 h-5 transition-transform ${isActive ? "scale-110" : ""}`} />
              <span className={`text-[10px] tracking-wide ${isActive ? "font-semibold" : "font-medium"}`}>{tab.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
